<template>
    <div>
        <span class="data-label">
            <div class="ellipsis">{{ forceLabel ? forceLabel : label }}</div>
            <i
                v-if="useFavorite"
                :class="['blue ml-2 fs-2 cpointer data-label-icon-toggle', isFavoriteClass]"
                @click.prevent="toggleFavorite"
            ></i>
            <i
                v-if="canRemoveFavorite"
                class="icon-close primary-50 ml-2 fs-2 cpointer"
                @click.prevent="toggleFavorite"
            ></i>
        </span>
        <span class="data-value copy-element">
            <email-link
                :linkedtype="linkedtype"
                :class="canRemoveFavorite ? 'ellipsis' : ''"
                :linkedid="parseInt(linkedid)"
                :email="value"
            >
                {{ value }}
            </email-link>
            <SaasClipboard v-if="value" :data="value" />
        </span>
    </div>
</template>

<script>
import FavoriteHeaderMixins from '../../../../mixins/FavoriteHeaderMixins';
import DataValueMixin from '../../../../mixins/DataValueMixins';
import EmailLink from 'vcomponents/email/EmailLink.vue';
import SaasClipboard from 'vcomponents/utilities/SaasClipboard.vue';

export default {
    components: {
        'email-link': EmailLink,
        SaasClipboard,
    },
    mixins: [FavoriteHeaderMixins, DataValueMixin],
    props: {
        linkedid: {
            type: Number,
            required: false,
        },
        linkedtype: {
            type: String,
            required: false,
        },
    },
};
</script>

<style scoped>
.data-label {
    display: flex;
    flex-direction: row;
    align-items: center;
}
</style>
